import { useState, useEffect } from 'react';
import ColorWheel from './circle';
import ColorSlider from './slider';
import {
  Container,
  ColorSlidersContainer,
  Button,
} from './styles';

/* eslint-disable */
function HSLToHex(h, s, l) {
  s /= 100;
  l /= 100;

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs((h / 60) % 2 - 1));
  const m = l - c / 2;
  let r = 0;
  let g = 0;
  let b = 0;

  if (h >= 0 && h < 60) {
    r = c; g = x; b = 0;
  } else if (h >= 60 && h < 120) {
    r = x; g = c; b = 0;
  } else if (h >= 120 && h < 180) {
    r = 0; g = c; b = x;
  } else if (h >= 180 && h < 240) {
    r = 0; g = x; b = c;
  } else if (h >= 240 && h < 300) {
    r = x; g = 0; b = c;
  } else if (h >= 300 && h < 360) {
    r = c; g = 0; b = x;
  }
  // Having obtained RGB, convert channels to hex
  r = Math.round((r + m) * 255).toString(16);
  g = Math.round((g + m) * 255).toString(16);
  b = Math.round((b + m) * 255).toString(16);

  // Prepend 0s, if necessary
  if (r.length === 1) r = `0${r}`;
  if (g.length === 1) g = `0${g}`;
  if (b.length === 1) b = `0${b}`;

  return `#${r}${g}${b}`;
}

function hexToHSL(H) {
  let r = 0;
  let g = 0;
  let b = 0;

  if (H.length === 4) {
    r = `0x${H[1]}${H[1]}`;
    g = `0x${H[2]}${H[2]}`;
    b = `0x${H[3]}${H[3]}`;
  } else if (H.length === 7) {
    r = `0x${H[1]}${H[2]}`;
    g = `0x${H[3]}${H[4]}`;
    b = `0x${H[5]}${H[6]}`;
  }
  // Then to HSL
  r /= 255;
  g /= 255;
  b /= 255;
  const cmin = Math.min(r, g, b);
  const cmax = Math.max(r, g, b);
  const delta = cmax - cmin;
  let h = 0;
  let s = 0;
  let l = 0;

  if (delta === 0) h = 0;
  else if (cmax === r) h = ((g - b) / delta) % 6;
  else if (cmax === g) h = (b - r) / delta + 2;
  else h = (r - g) / delta + 4;

  h = Math.round(h * 60);

  if (h < 0) h += 360;

  l = (cmax + cmin) / 2;
  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  s = +(s * 100).toFixed(1);
  l = +(l * 100).toFixed(1);

  return [h, s, l];
}

/* eslint-enable */

const ColorWheelPicker = ({
  onChange,
  value,
}) => {
  const [color, setColor] = useState('#FF0000');
  const [resultingColor, setResultingColor] = useState('#FF0000');
  const [colorHsl, setColorHsl] = useState([0, 100, 50]);
  const [edgeDarkenColor, setEdgeDarkenColor] = useState([0, 100, 50]);
  const [edgeSaturatedColor, setEdgeSaturatedColor] = useState([0, 100, 50]);
  const [colorDarkness, setColorDarkness] = useState(50);
  const [colorSaturation, setColorSaturation] = useState(100);
  const darkenColor = (hsl, percent) => `hsl(${hsl[0]}, ${hsl[1]}%, ${percent}%)`;
  const saturatedColor = (hsl, percent) => `hsl(${hsl[0]}, ${percent}%, ${hsl[2]}%)`;
  const updateResultingColor = () => {
    setResultingColor(color);
  };
  const updateColor = (newColor) => {
    setColor(newColor);
    setColorHsl([hexToHSL(newColor)[0], colorSaturation, colorDarkness]);
  };

  const updateDarkness = (percent) => {
    setColorDarkness(percent / 2);
  };

  const updateSaturation = (percent) => {
    setColorSaturation(percent);
  };

  const addColor = (event) => {
    event.preventDefault();

    onChange([HSLToHex(...[colorHsl[0], colorSaturation, colorDarkness])]);
  };

  useEffect(() => {
    updateResultingColor();
  }, [colorDarkness, colorSaturation, colorHsl]);

  useEffect(() => {
    setColorHsl(hexToHSL(color));
    setEdgeDarkenColor(darkenColor(colorHsl, 0));
    setEdgeSaturatedColor(saturatedColor(colorHsl, 0));
  }, []);

  return (
    <Container>
      <ColorWheel
        resultingColor={HSLToHex(...[colorHsl[0], colorSaturation, colorDarkness])}
        onColorChange={updateColor}
      />
      <ColorSlidersContainer>
        <ColorSlider
          color={color}
          edgeColor={edgeSaturatedColor}
          value={colorSaturation}
          onSliderUpdate={updateSaturation}
        />
        <ColorSlider
          color={color}
          edgeColor={edgeDarkenColor}
          value={colorDarkness}
          onSliderUpdate={updateDarkness}
        />
        <Button
          title="Select new color"
          disabled={value.includes(resultingColor)}
          onClick={addColor}
        >
          <span>
            Add color
          </span>
        </Button>
      </ColorSlidersContainer>
    </Container>
  );
};

export default ColorWheelPicker;
